import { c as create_ssr_component, e as escape, b as add_attribute, v as validate_component } from "../../../../chunks/ssr.js";
import { E as EditorToolbar_1, P as PlainText } from "../../../../chunks/PlainText.js";
import { i as isEmailValid } from "../../../../chunks/util.js";
import "../../../../chunks/client.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let bio;
  let { data } = $$props;
  let editable = true, name = "", email = "";
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    data.currentUser;
    bio = data.bio;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-7rkme9_START -->${$$result.title = `<title>${escape(name)}</title>`, ""}<link rel="icon" type="image/png" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><link rel="apple-touch-icon" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><!-- HEAD_svelte-7rkme9_END -->`, ""} ${`${validate_component(EditorToolbar_1, "EditorToolbar").$$render(
      $$result,
      {
        confirmLabel: "Create",
        canConfirm: isEmailValid(email)
      },
      {},
      {}
    )}`} <div class="max-w-screen-md mx-auto px-6 pb-8 sm:text-xl"><div class="pt-24 text-sm font-bold" data-svelte-h="svelte-1xdkiug">Name</div> <div class="border-b py-2">${validate_component(PlainText, "PlainText").$$render(
      $$result,
      {
        editable,
        placeholder: "Enter name",
        content: name
      },
      {
        content: ($$value) => {
          name = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div> <div class="pt-8 text-sm font-bold" data-svelte-h="svelte-1x5rrvd">Email</div> <div class="border-b py-2">${validate_component(PlainText, "PlainText").$$render(
      $$result,
      {
        editable,
        placeholder: "Enter email",
        content: email
      },
      {
        content: ($$value) => {
          email = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div>`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
